import { all, call, put, takeLatest } from 'redux-saga/effects';

import {
  getDashboardData,
  getDashboardDataFailed,
  getDashboardDataSuccess,
  getDepartedUsers,
  getDepartedUsersFailed,
  getDepartedUsersSuccess,
  getFilteredInterns,
  getFilteredInternsFailed,
  getFilteredInternsSuccess,
  getFilteredCandidates,
  getFilteredCandidatesFailed,
  getFilteredCandidatesSuccess,
  getTasksOverview,
  getTasksOverviewFailed,
  getTasksOverviewSuccess,
  getTasksOverviewById,
  getTasksOverviewByIdFailed,
  getTasksOverviewByIdSuccess,
  getMyProjectLeaders,
  getMyProjectLeadersFailed,
  getMyProjectLeadersSuccess,
  getProjectContribution,
  getProjectContributionSuccess,
  getProjectContributionFailed,
  getTaskAssignment,
  getTaskAssignmentFailed,
  getTaskAssignmentSuccess,
  getRemainingTasksSuccess,
  getRemainingTasksFailed,
  getRemainingTasks,
} from './slice';
import { request } from '@app/services';
import * as endpoints from './endpoint';

function* getDashboardDataSaga(action: ReturnType<typeof getDashboardData>): any {
  try {
    const result = yield call(request.get, endpoints.getDashboardData);
    yield put(getDashboardDataSuccess(result.data));
  } catch (err) {
    yield put(getDashboardDataFailed(err));
  }
}
//
function* getDepartedUsersSaga(action: ReturnType<typeof getDepartedUsers>): any {
  try {
    const q = action.payload;
    const result = yield call(request.get, endpoints.departedUser, {
      params: {
        year: q,
      },
    });
    yield put(getDepartedUsersSuccess(result.data));
  } catch (err) {
    yield put(getDepartedUsersFailed(err));
  }
}
//
function* getFilteredInternsSaga(action: ReturnType<typeof getFilteredInterns>): any {
  try {
    const { formattedDate, formattedMonth } = action.payload;
    const result = yield call(request.get, endpoints.getFilteredInterns, {
      params: {
        month: formattedMonth,
        date: formattedDate,
      },
    });
    yield put(getFilteredInternsSuccess(result.data));
  } catch (err) {
    yield put(getFilteredInternsFailed(err));
  }
}
//
function* getFilteredCandidatesSaga(action: ReturnType<typeof getFilteredCandidates>): any {
  try {
    const { formattedDate, formattedMonth } = action.payload;
    const result = yield call(request.get, endpoints.getFilteredCandidates, {
      params: {
        month: formattedMonth,
        date: formattedDate,
      },
    });
    yield put(getFilteredCandidatesSuccess(result.data));
  } catch (err) {
    yield put(getFilteredCandidatesFailed(err));
  }
}
//
function* getTasksOverviewSaga(action: ReturnType<typeof getTasksOverview>): any {
  try {
    const projectId = action.payload;
    // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions
    const result = yield call(request.get, `${endpoints.getTasksOverview}${projectId}`);
    yield put(getTasksOverviewSuccess(result.data));
  } catch (err) {
    yield put(getTasksOverviewFailed(err));
  }
}
//
function* getTasksOverviewByIdSaga(action: ReturnType<typeof getTasksOverviewById>): any {
  try {
    const { projectId, createdBy } = action.payload;
    const result = yield call(
      request.get,
      // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions
      `${endpoints.getTasksOverviewById}${createdBy}/${projectId}`
    );
    yield put(getTasksOverviewByIdSuccess(result.data));
  } catch (err) {
    yield put(getTasksOverviewByIdFailed(err));
  }
}
//
function* getMyProjectLeadersSaga(action: ReturnType<typeof getMyProjectLeaders>): any {
  try {
    const { userId, status } = action.payload;
    const result = yield call(
      request.get,
      // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions
      `${endpoints.getMyProjectLeaders}${userId}/${status}`
    );
    yield put(getMyProjectLeadersSuccess(result.data));
  } catch (err) {
    yield put(getMyProjectLeadersFailed(err));
  }
}
//
function* getProjectContributionSaga(action: ReturnType<typeof getProjectContribution>): any {
  try {
    const { userId } = action.payload;
    const result = yield call(
      request.get,
      // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions
      `${endpoints.getProjectContribution}${userId}`
    );
    yield put(getProjectContributionSuccess(result.data));
  } catch (err) {
    yield put(getProjectContributionFailed(err));
  }
}
//
function* getTaskAssignmentSaga(action: ReturnType<typeof getTaskAssignment>): any {
  try {
    const result = yield call(request.get, endpoints.getTaskAssignment);
    yield put(getTaskAssignmentSuccess(result.data));
  } catch (err) {
    yield put(getTaskAssignmentFailed(err));
  }
}
//
function* getRemainingTasksSaga(action: ReturnType<typeof getRemainingTasks>): any {
  try {
    const { userId } = action.payload;
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    const result = yield call(request.get, endpoints.getRemainingTasks + userId);
    yield put(getRemainingTasksSuccess(result.data));
  } catch (err) {
    yield put(getRemainingTasksFailed(err));
  }
}
//
function* DashboardSagas() {
  yield all([
    takeLatest([getDashboardData], getDashboardDataSaga),
    takeLatest(getDepartedUsers, getDepartedUsersSaga),
    takeLatest(getFilteredInterns, getFilteredInternsSaga),
    takeLatest(getFilteredCandidates, getFilteredCandidatesSaga),
    takeLatest(getTasksOverview, getTasksOverviewSaga),
    takeLatest(getTasksOverviewById, getTasksOverviewByIdSaga),
    takeLatest(getMyProjectLeaders, getMyProjectLeadersSaga),
    takeLatest(getProjectContribution, getProjectContributionSaga),
    takeLatest(getTaskAssignment, getTaskAssignmentSaga),
    takeLatest(getRemainingTasks, getRemainingTasksSaga),
  ]);
}
export { DashboardSagas };
